import SubHeader from '../../Sub-Header/Sub-Header';
import EnquiryForm from './EnquiryForm/Enquiry-Form';
import StreetMap from './StreetMap/Street-Map';
import ImageContainer from '../../PageStyling/ImageContainer';

import styles from './Find.module.css';
import '../../../App.css';


const findReel = {
    "image1": require('./images/find-left.webp'),
    "image2": require('./images/find-middle.webp'),
    "image3": require('./images/find-right.webp')
};

const altImage = { 
    "image1Alt" : "Gluten Free Carrot Cake",
    "image2Alt" : "Croissants",
    "image3Alt" : "Berry Danish",
}

function Find() { 
    return ( 
        <div>
            <SubHeader>
                <div className={styles['find-sub-container']}>
                    <p>Thanks to the generosity of Hominy Bakery we're currently popping up in their shopfront every Sunday.</p>
                    <p>185 Katoomba Street</p>
                    <p>From 8am</p>
                </div>
            </SubHeader>
            <div className='page-container'>
                <div className='desktop-padding' />
                <div className='page'>     
                    <div className={styles['locate-container']}>
                        <div className={styles['enquiry-container']}>
                            <EnquiryForm />
                        </div>
                        <div className={styles['map-container']}>
                            <div className={styles['map-box']}>
                                <StreetMap />
                            </div>
                        </div>
                    </div>
                    <hr />
                    <ImageContainer reel={findReel} alt={altImage} />
                </div>
                <div className='desktop-padding' />
            </div>
        </div>
    );
};

export default Find; 